import { createStateContext } from "react-use";
import React, { useEffect } from "react";
import { useState } from "react";
import { colors, Divider, Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import GroupLists from "./GroupLists";
import { sto } from "../../../../Context/InshData";
import axios from "axios";
import { uri } from "../../../../help/Api";
import RestItemsG from "./RestItemsG";

export const [useSharedGroupId, SharedGroupIdProvider] = createStateContext(-1);

const useStyles = makeStyles((theme) => ({
    root: {
        paddingBottom: theme.spacing(3),
        // marginBottom:"1.5rem",
    },
}));

export function RestProductsG(props) {
    const { dataTable, groups, groupsSub, permistionInv, valueSafes, localCasheItems, setLocalCasheItems } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [groupId, setGroupId] = useState(-1);

    const [subGroupId, setSubGroupId] = useState(-1);
    const [GroupColor, setGroupColor] = useState({});
    const [group, setGroup] = useState({});

    const [subGroups, setSubGroups] = useState([]);

    const clasup = useStyles();

    const onRowClick = (row) => {
        setGroupId(row.id);
        setGroupId(row.id);
        setGroupColor({ ...row, color: colors.blue[300] });
        setSubGroups([]);

        const subs = groupsSub?.filter((g) => g.parentId == row.id);
        setSubGroups(subs);
        setGroup(row);

        if (subs?.length > 0) {
            setSubGroupId(subs[0]?.id);
            setGroup(row);
        }
        else {
            setSubGroupId(row.id);
            setGroup(row);
        }
        viewHandle(row.id);
    };
    const onRowClickSub = (row) => {
        setGroupId(row.id);
        setGroupId(row.id);
        let clickColor = 8421504;
        setGroupColor({ ...row, color: colors.blue[300] });
        setSubGroupId(row.id);
        setGroup(row);
        viewHandle(row.id);
    };
    useEffect(() => {
    }, [subGroupId, dataTable]);
    const [page, setPage] = useState(0);
    const [loadmore, setLoadmore] = useState(true);
    const viewHandle = async (group_id) => {
        setData([]);
        setLoading(true);
        const newItem = localCasheItems.find((obj) => obj.group_id.toString() === group_id.toString());
        if (newItem) {
            setData(newItem?.items);
            setLoading(false);
        } else {
            viewHandleSearch(group_id);
        }
    };

    const viewHandleSearch = async (group_id) => {
        setData([]);
        setLoading(true);
        let Urls = null;
        if (permistionInv?.SHOW_UNITS) {
            Urls = uri + `RptSafes/ItemsInvSearch?currShow=${-1} &&curr_type=${-1}&&groupid=${group_id}&&take=${100}
        &&item_code=${''}&&item_name=${''}&&emp=${sto.empi}&&procInvType=${"02"}&&safe=${valueSafes.id}`;
        } else {
            Urls = uri + `RptSafes/ItemsSearch?currShow=${"D"}
        &&curr_type=${-1}&&groupid=${group_id}&&take=${100}&&item_code=${''}&&item_name=${''} &&emp=${sto.empi}`;
        };
        await axios.get(Urls).then((res) => {
            const dataItems = res.data.map((row, i) => {
                return {
                    ...row,
                    val1: 1,
                    val: 0,

                };
            });
            const newItem = localCasheItems.find((obj) => obj.group_id.toString() === group_id.toString());
            if (!newItem) {
                const addNewItem = { group_id: group_id, items: dataItems }
                setLocalCasheItems([...localCasheItems, addNewItem]);
            }
            setData(dataItems);
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            setData([]);
        });
    };

    return (
        <React.Fragment>
            <div className={clasup.root}>

                <Typography
                    component="div"
                    style={{ direction: "rtl" }}
                >

                    <Grid item xs={12} container spacing={0} >

                        <Grid item lg={2} md={2} sm={4} xs={3}>
                            <Paper
                                style={{ minHeight: "70vh", maxHeight: "70vh", overflow: "auto", }}
                            >
                                <SharedGroupIdProvider>
                                    <GroupLists
                                        groups={[...groups]}
                                        onRowClick={onRowClick}
                                        isMain={true}
                                        GroupColor={GroupColor}

                                    />
                                    <Divider />

                                </SharedGroupIdProvider>
                            </Paper>
                        </Grid>

                        {subGroups.length > 0 ? (
                            <>

                                <Grid item lg={2} md={2} sm={2} xs={3}>
                                    <Paper
                                        style={{ minHeight: "70vh", maxHeight: "70vh", overflow: "auto", }}
                                    >
                                        <SharedGroupIdProvider>
                                            <GroupLists
                                                groups={[...subGroups]}
                                                onRowClick={onRowClickSub}
                                                isMain={false}
                                                GroupColor={GroupColor}
                                            />
                                        </SharedGroupIdProvider>
                                    </Paper>
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={3}>
                                    <Paper
                                        style={{ minHeight: "70vh", maxHeight: "70vh", overflow: "auto", }}
                                    >
                                        <SharedGroupIdProvider>
                                            <RestItemsG
                                                onSelectItem={props.onSelectItem}
                                                values={dataTable}
                                                groupId={subGroupId}
                                                BefrowDataCurrencie={null}
                                                group={group}
                                                data={data ? data : []}
                                                loading={loading}
                                            />
                                        </SharedGroupIdProvider>
                                    </Paper>
                                </Grid>
                            </>
                        ) :
                            (
                                <Grid item lg={10} md={10} sm={10} xs={10}>
                                    <Paper
                                        style={{ minHeight: "70vh", maxHeight: "70vh", overflow: "auto", }}
                                    >
                                        <SharedGroupIdProvider>
                                            <RestItemsG
                                                onSelectItem={props.onSelectItem}
                                                values={dataTable}
                                                groupId={subGroupId}
                                                BefrowDataCurrencie={null}
                                                group={group}
                                                data={data ? data : []}
                                                loading={loading}
                                            />
                                        </SharedGroupIdProvider>
                                    </Paper>
                                </Grid>
                            )
                        }
                    </Grid>
                </Typography>
            </div>
        </React.Fragment>
    );
}
